// @flow
import CompetitionResultPool from 'components/competition/CompetitionResultPool';
import { connect } from 'react-redux';

import type { StateProps } from 'components/competition/CompetitionResultPool';
import type { StateType } from 'types/Actions';

export default connect(
  (state: StateType): StateProps => ({
    slug: state.competitionState.competition.slug,
    participants: state.competitionState.competition.participants,
    prevDay: state.competitionState.competition.prevDay,
    nextDay: state.competitionState.competition.nextDay,
  })
)(CompetitionResultPool);
